/**
 * 攻略分类
 */
import React from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import { message, Card, Row, Col, Switch, Tooltip, Empty } from 'antd';
import { showConfirm } from '@/components/xqxc_ui';
import http from '@/assets/api/http';
import { connect } from 'react-redux';
import model from '@/reducers/client/help/strategy/model';
import { PlusOutlined } from '@ant-design/icons';
import { TableActionType as ta } from '@/util/enum';
import { State, RoleTypeDesc } from '../types';
import InfoModal from './modal/InfoModal';
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';
import { TweenOneGroup } from 'rc-tween-one';
import { setBreadcrumbPaths } from '@/reducers/home/actions';

const DragHandle = SortableHandle(({ children }) => <span className={styles.title}>{children}</span>);

const SortableItem = SortableElement(({ card, actionHandle, toAll }) => (
    <Col className={styles.card} span={6}>
        <Card
            hoverable
            title={
                <>
                    <DragHandle>{card.className}</DragHandle>
                    <a className={styles.all} onClick={() => toAll(card)}>全部</a>
                </>
            }
            actions={[
                <div className={styles.actions} key={card.id}>
                    <a className={styles.edit} onClick={() => actionHandle(card.id, ta.edit, card)}>编辑</a>
                    <a className={styles.delete} onClick={() => actionHandle(card.id, ta.delete, card)}>删除</a>
                    <Switch checked={card.status === State.start} onChange={(value) => actionHandle(value, ta.state, card)} />
                </div>
            ]}
        >
            <ul className={styles.articleList}>
                {card.listStrategyInfo.length > 0
                    ? card.listStrategyInfo.map((v, i) =>
                        <Tooltip title={v.title} placement='topLeft' key={v.id}>
                            <li key={v.id} onClick={() => actionHandle(v.id, ta.link, card)}>{i + 1}. {v.title}</li>
                        </Tooltip>
                    )
                    : <li><Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={null} /></li>
                }
            </ul>
        </Card>
    </Col>
));

const SortableList = SortableContainer(({ tableSource, newHandle, ...props }) => {
    return (
        <TweenOneGroup
            enter={{
                scale: 0.8,
                opacity: 0,
                type: 'from',
                duration: 100,
                onComplete: e => {
                    e.target.style = '';
                }
            }}
            leave={{ opacity: 0, width: 0, scale: 0, duration: 200 }}
            appear={false}
        >
            <div style={{ marginTop: 10, color: '#808080' }}>提示：长按分类标题拖拽排序</div>
            <Row gutter={16} className={styles.cardList}>
                <Col span={6} key={0}> 
                    <Card
                        hoverable
                        style={{ height: 202, textAlign: 'center', cursor: 'pointer' }}
                        onClick={newHandle}
                    >
                        <PlusOutlined style={{ fontSize: 50, marginTop: 30 }} />
                        <div style={{ fontSize: 18, marginTop: 10 }}>新建分类</div>
                    </Card>
                </Col>
                {tableSource.map((card, index) => <SortableItem key={card.id} index={index} card={card} {...props} />)}
            </Row>
        </TweenOneGroup>
    );
});

class Main extends React.Component {

    state = {
        currentOpenMode: '',
        openModeParam: {},
        positionList: []
    }

    componentDidMount() {
        const { match, setBreadcrumbPaths } = this.props;
        setBreadcrumbPaths(match);
        this._searchHandle();
        http('/?cmd=com.xqxc.api.pig.mis.biz.platform.StrategyDisplayPositionService.listStrategyDisplayPosition', { systemType: this.props.curTabID }, 'POST').then((res) => {
            if (res.errCode === 0) {
                this.setState({ positionList: res.result });
            }
        });
    }

    _newHandle = () => {
        this.setState({ currentOpenMode: ta.create });
    }

    _searchHandle = () => {
        this.props.getTableSource({ systemType: this.props.curTabID });
    }

    _actionHandle = (value, type, item) => {
        switch (type) {
            case ta.link:
                console.log(item.className);
                this.props.history.push({ pathname: `/home/client/help/strategy/article/${item.id}/${ta.edit}/${value}` })
                break;
            case ta.edit:
                this.setState({ currentOpenMode: ta.edit, openModeParam: item });
                break;
            case ta.state:
                http('/?cmd=com.xqxc.api.pig.mis.biz.platform.StrategyMisService.updateStrategyClassStatus', { id: item.id, status: value ? State.start : State.close }, 'POST')
                    .then(() => {
                        this._searchHandle();
                    }).catch((reject) => message.error(reject.message));
                break;
            case ta.delete:
                showConfirm(`是否删除？`, '', () => {
                    http('/?cmd=com.xqxc.api.pig.mis.biz.platform.StrategyMisService.delStrategyClass', { id: value }, 'POST')
                        .then(() => {
                            message.success(`操作成功!`);
                            this._searchHandle();
                        }).catch((reject) => message.error(reject.message));
                });
                break;
        }

    }

    // 打开弹窗  
    _renderMode = () => {
        switch (this.state.currentOpenMode) {
            case ta.create:
                return <InfoModal title='创建分类' visible={true} curTabID={this.props.curTabID} type={ta.create} positionList={this.state.positionList} data={this.state.openModeParam} closeMode={this._closeMode} />;
            case ta.edit:
                return <InfoModal title='编辑分类' visible={true} curTabID={this.props.curTabID} type={ta.edit} positionList={this.state.positionList} data={this.state.openModeParam} closeMode={this._closeMode} />;
            default:
                return null;
        }
    }

    _toAll = (item) => {
        this.props.history.push({
            pathname: '/home/client/help/strategy/article/' + item.id,
            search: `titleName=${RoleTypeDesc[this.props.curTabID]} - ${item.className}`,
        });
    }

    // 关闭弹框
    _closeMode = (reload) => {
        this.setState({ currentOpenMode: '', openModeParam: {} });
        reload && this._searchHandle();
    }

    onSortEnd = ({ oldIndex, newIndex }) => {

        let item = this.props.tableSource[oldIndex];

        http('/?cmd=com.xqxc.api.pig.mis.biz.platform.StrategyMisService.updateStrategyClassSortNo', {
            id: item.id,
            systemType: this.props.curTabID,
            sortNo: newIndex + 1
        }, 'POST')
            .then(() => this._searchHandle())
            .catch((reject) => message.error(reject.message));
    }

    render() {

        return (
            <div>
                <SortableList useDragHandle helperClass={styles.cardList} axis='xy' onSortEnd={this.onSortEnd} tableSource={this.props.tableSource} newHandle={this._newHandle} toAll={this._toAll} actionHandle={this._actionHandle} />
                {this._renderMode()}
            </div>
        );
    }
}

Main.propTypes = {
    history: PropTypes.object,
    curTabID: PropTypes.string,

    getTableSource: PropTypes.func,
    tableSource: PropTypes.array,
    match: PropTypes.object, // 路由match对象
    setBreadcrumbPaths: PropTypes.func
};
const mapStateToProps = (state) => ({
    tableSource: state.help_strategy.tableSource,
});

export default connect(mapStateToProps, { ...model.actions, setBreadcrumbPaths })(Main);